// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ApplicationKindSchema = z.enum(['WEB_APPLICATION','AI_APPLICATION'] as const);

export type ApplicationKindType = `${z.infer<typeof ApplicationKindSchema>}`

export default ApplicationKindSchema;
